import React, { useState } from 'react';
import useModal from 'Hooks/useModal';
import { useSelector } from 'react-redux';
import { selectUserName } from 'store/Faraday/selectors';
import Settings from 'Screens/Contextualization/Settings';
import Extras from './Modals/Extras';
import About from './Modals/About';
import Help from './Modals/Help';
import User from '.';

const UserContainer = () => {
  const [ModalPreferences, showModalPreferences, toggleModalPreferences] = useModal(Settings);
  const [ModalExtras, showModalExtras, toggleModalExtras] = useModal(Extras);
  const [ModalAbout, showModalAbout, toggleModalAbout] = useModal(About);
  const [ModalHelp, showModalHelp, toggleModalHelp] = useModal(Help);
  const [dropdown, setDropdown] = useState(false);
  const userRole = useSelector((s) => s.faraday.role);
  const userName = useSelector(selectUserName);

  const modals = {
    Extras: {
      Modal: ModalExtras,
      showModal: showModalExtras,
      toggleModal: toggleModalExtras
    },
    About: {
      Modal: ModalAbout,
      showModal: showModalAbout,
      toggleModal: toggleModalAbout
    },
    Help: {
      Modal: ModalHelp,
      showModal: showModalHelp,
      toggleModal: toggleModalHelp
    },
    Preferences: {
      Modal: ModalPreferences,
      showModal: showModalPreferences,
      toggleModal: toggleModalPreferences
    }
  };

  const handleOutsideClick = () => {
    setDropdown(false);
    document.removeEventListener('click', handleOutsideClick);
  };

  const handleClick = () => {
    if (dropdown) setDropdown(false);
    else {
      setDropdown(true);
      document.addEventListener('click', handleOutsideClick);
    }
  };

  return <User modals={ modals } userName={ userName } userRole={ userRole } dropdown={ dropdown } onClick={ handleClick } />;
};

export default UserContainer;
